import { render, staticRenderFns } from "./LearningDetail.vue?vue&type=template&id=116207f0&scoped=true&"
import script from "./LearningDetail.vue?vue&type=script&lang=js&"
export * from "./LearningDetail.vue?vue&type=script&lang=js&"
import style0 from "./LearningDetail.vue?vue&type=style&index=0&id=116207f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116207f0",
  null
  
)

export default component.exports